import React from 'react';
import {
MDBCarousel,
MDBCarouselItem,
} from 'mdb-react-ui-kit';

import styles from './galeria.module.css'
import galeria1 from '../../img/galeria1.jpg'
import galeria2 from '../../img/galeria2.jpg'
import galeria3 from '../../img/galeria3.jpg'
import galeria4 from '../../img/galeria4.jpg'
import galeria5 from '../../img/galeria5.jpg'
import galeria6 from '../../img/galeria6.jpg'
import galeria7 from '../../img/Con el sexteto de Raúl Garello.jpg'
import galeria8 from '../../img/En la Universidad Nacional de las Artes 2022 (1).jpg'
import galeria9 from '../../img/Junto a Néstor Marconi en la Embajada de Francia en Argentina 2017.jpg'
import galeria10 from '../../img/Teato Colsubsidio de Bogotá 2022 (1).jpg'
import galeria11 from '../../img/En el Teatro Colón.jpeg'

function Galeria() {
return (
    <div className="multimedia">
    <div className={styles.galeriaContainer} id='galeria'>
        <h3 className={styles.sectionTitle}>GALERIA DE IMAGENES</h3>
        <MDBCarousel showControls showIndicators fade className={styles.carouselContainer}>
        <MDBCarouselItem itemId={1} className={styles.carItem}>
        <img
            src={galeria1}
            className="d-block w-100"
            alt="111111111111"
        />

        </MDBCarouselItem>

        <MDBCarouselItem itemId={2} className={styles.carItem}>
        <img
            src={galeria2}
            className="d-block w-100"
            alt="Sunset Over the City"
        />

        </MDBCarouselItem>

        <MDBCarouselItem itemId={3} className={styles.carItem}>
        <img
            src={galeria3}
            className="d-block w-100"
            alt="Sunset Over the City"
        />

        </MDBCarouselItem>
        <MDBCarouselItem itemId={4} className={styles.carItem}>
        <img
            src={galeria4}
            className="d-block w-100"
            alt="Sunset Over the City"
        />
        </MDBCarouselItem>
        <MDBCarouselItem itemId={5} className={styles.carItem}>
        <img
            src={galeria5}
            className="d-block w-100"
            alt="Sunset Over the City"
        />

        </MDBCarouselItem>
        <MDBCarouselItem itemId={6} className={styles.carItem}>
        <img
            src={galeria6}
            className="d-block w-100"
            alt="Sunset Over the City"
        />

        </MDBCarouselItem>
        <MDBCarouselItem itemId={7} className={styles.carItem}>
        <img
            src={galeria7}
            className="d-block w-100"
            alt="Sunset Over the City"
        />

        </MDBCarouselItem>
        <MDBCarouselItem itemId={8} className={styles.carItem}>
        <img
            src={galeria8}
            className="d-block w-100"
            alt="Sunset Over the City"
        />

        </MDBCarouselItem>
        <MDBCarouselItem itemId={9} className={styles.carItem}>
        <img
            src={galeria9}
            className="d-block w-100"
            alt="Sunset Over the City"
        />

        </MDBCarouselItem>
        <MDBCarouselItem itemId={10} className={styles.carItem}>
        <img
            src={galeria10}
            className="d-block w-100"
            alt="Sunset Over the City"
        />

        </MDBCarouselItem>
        <MDBCarouselItem itemId={11} className={styles.carItem}>
        <img
            src={galeria11}
            className="d-block w-100"
            alt="Sunset Over the City"
        />

        </MDBCarouselItem>
        
    </MDBCarousel>
    </div>
    
    <div className={styles.videosContainer}>
        <h3 className={styles.sectionTitle}>VIDEOS</h3>
        <div className={styles.videosGrid}>
        <div className={styles.videoWrapper}>
            <iframe src="https://www.youtube.com/embed/4vgF07FnyuQ" title="Lautaro Mazza & Oscar De Elía - Tango 'Anoche'" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerPolicy="strict-origin-when-cross-origin" allowFullScreen></iframe>
        </div>
        <div className={styles.videoWrapper}>
            <iframe src="https://www.youtube.com/embed/qxaBVrZJWcw" title="'Balada para un loco'. Lautaro Mazza en la Cumbre Mundial del Tango 2023" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerPolicy="strict-origin-when-cross-origin" allowFullScreen></iframe>
        </div>
        <div className={styles.videoWrapper}>
            <iframe src="https://www.youtube.com/embed/KGl1fIutmiU" title="Tenés servido el té de Cátulo Castillo y Héctor Stamponi" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerPolicy="strict-origin-when-cross-origin" allowFullScreen></iframe>
        </div>
        <div className={styles.videoWrapper}>
            <iframe src="https://www.youtube.com/embed/3g5wAP7VkaI" title="Chau no va más (Homero Expósito/ Virgilio Expósito)" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerPolicy="strict-origin-when-cross-origin" allowFullScreen></iframe>
        </div>
        <div className={styles.videoWrapper}>
            <iframe src="https://www.youtube.com/embed/F9nWAdUwu5E" title="Orquesta del Tango de la Ciudad de Buenos Aires - 'Viejo Buenos Aires'" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerPolicy="strict-origin-when-cross-origin" allowFullScreen></iframe>
        </div>
        </div>
    </div>
    </div>
);
}

export default Galeria;